import { Box, Skeleton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const ProfileSkeleton = () => {
  return (
    <Box>
      <Box
        sx={{
          border: "1px solid rgba(183, 124, 10, 0.18)",
          borderRadius: "18px",
          p: 3,
          mb: 4,
          background: "rgba(255,255,255,0.96)",
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid size={{ xs: 12, md: 2.5 }} sx={{ textAlign: "center" }}>
            <Skeleton
              variant="circular"
              width={110}
              height={110}
              sx={{ m: "auto" }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 9.5 }}>
            <Skeleton width={240} height={42} />
            <Skeleton width="70%" height={26} sx={{ mt: 1 }} />
            <Box sx={{ display: "flex", gap: 1, mt: 2, flexWrap: "wrap" }}>
              <Skeleton variant="rounded" width={130} height={32} />
              <Skeleton variant="rounded" width={140} height={32} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Typography variant="h6" gutterBottom>
        <Skeleton width={180} />
      </Typography>
      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Skeleton variant="rounded" height={220} />
          <Skeleton variant="rounded" height={140} sx={{ mt: 2 }} />
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <Skeleton variant="rounded" height={340} />
        </Grid>
      </Grid>
    </Box>
  );
};
